<template>
    <div class="dropdown">
        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button"
           aria-haspopup="true" aria-expanded="false">
            Werkzeuge
        </a>
        <div class="dropdown-menu">
            <a v-for="t in tools" class="dropdown-item" target="_blank"
               :key="t.link"
               :title="t.title" :href="t.link">
                <span :class="t.icon" aria-hidden="true"></span>
                {{t.name}}
            </a>
        </div>
    </div>
</template>

<script>

const TOOLS = [
  {
    link: "nexplorer.html",
    name: "Datei Explorer",
    title: "Dateien in Virtual File System verwalten",
    icon: "fa fa-file-code-o"
  },
  {
    link: "database-manager.html",
    name: "Datenbank-Tabellen",
    title: "Datenbank-Tabellen von LaplaceScript verwalten",
    icon: "fa fa-table"
  },
  {
    link: "lti-manager.html",
    name: "LTI-Manager",
    title: "LTI-Anbindung von MathCoach-Aufgaben verwalten",
    icon: "fa fa-puzzle-piece"
  }
];

export default {
  name: "tool-dropdown-menu",
  computed: {
    tools() {
      if (window) {
        let windowLink = window.location.pathname;
        return TOOLS.filter(t => !windowLink.endsWith(t.link));
      }
      return TOOLS;
    }
  }
};
</script>

<style scoped>
</style>
